"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureHeader = void 0;
const openCharacterRuntime_1 = require("../utils/openCharacterRuntime");
class AdventureHeader {
    constructor(data) {
        this.id = data.id;
        this.title = data.title;
        this.description = data.description;
        this.subAdventures = data.subAdventures ? [...data.subAdventures] : undefined;
        this.characters = [...data.characters]; // Create a copy to prevent mutation
        this.players = data.players ? [...data.players] : undefined; // Create a copy to prevent mutation
        this.tags = data.tags ? [...data.tags] : undefined;
        this.style = data.style;
        this.titleImageId = data.titleImageId || 'generic';
        this.bannerId = data.bannerId || data.titleImageId || 'generic';
        this.tickIntervalMs = data.tickIntervalMs;
        this.hideHeaderForGuests = data.hideHeaderForGuests;
        this.library = data.library;
    }
    /**
     * Resolve authored template name or open-character instance (`Musician#2`) to the definition.
     */
    getCharacter(name) {
        return (0, openCharacterRuntime_1.resolveCharacter)(this.characters, name);
    }
    hasCharacter(name) {
        return this.getCharacter(name) !== undefined;
    }
    getCharacterNames() {
        return this.characters.map(char => char.name);
    }
    /**
     * Get description as plain text (for backward compatibility)
     */
    getDescriptionAsText() {
        if (typeof this.description === 'string') {
            return this.description;
        }
        // Convert rich text to plain text
        return this.description.elements
            .map(element => this.elementToPlainText(element))
            .join('\n\n');
    }
    /**
     * Convert a single rich text element to plain text
     */
    elementToPlainText(element) {
        if (typeof element === 'string') {
            return element;
        }
        if (element.type === 'paragraph' && Array.isArray(element.content)) {
            return element.content.map((item) => this.elementToPlainText(item)).join('');
        }
        if (element.type === 'heading') {
            const prefix = '#'.repeat(element.level || 1) + ' ';
            if (typeof element.content === 'string') {
                return prefix + element.content;
            }
            else {
                return prefix + element.content.map((item) => this.elementToPlainText(item)).join('');
            }
        }
        if (element.type === 'list' && Array.isArray(element.content)) {
            return element.content
                .map((item, index) => {
                const prefix = element.listType === 'numbered' ? `${index + 1}. ` : '- ';
                return prefix + this.elementToPlainText(item);
            })
                .join('\n');
        }
        if (typeof element.content === 'string') {
            return element.content;
        }
        if (Array.isArray(element.content)) {
            return element.content.map((item) => this.elementToPlainText(item)).join('');
        }
        return '';
    }
    toJSON() {
        return {
            id: this.id,
            title: this.title,
            description: this.description,
            subAdventures: this.subAdventures ? [...this.subAdventures] : undefined,
            characters: [...this.characters],
            players: this.players ? [...this.players] : undefined,
            tags: this.tags ? [...this.tags] : undefined,
            style: this.style,
            titleImageId: this.titleImageId,
            bannerId: this.bannerId,
            tickIntervalMs: this.tickIntervalMs,
            hideHeaderForGuests: this.hideHeaderForGuests,
            library: this.library
        };
    }
}
exports.AdventureHeader = AdventureHeader;
//# sourceMappingURL=AdventureHeader.js.map